// jQuery(document).ready(function($){
// 	var pageUrl = window.location.href;
//     if (pageUrl.indexOf("collections") > -1) {
//         if (pageUrl.indexOf("sort_by") > -1) {
// //           if (pageUrl.indexOf("best-selling") > -1) {
// //             var newSortby = 'created-ascending'; 
// //             var pageUrl = pageUrl.replace('best-selling',newSortby);
// //             window.location.href = pageUrl;
// //           }	
//         }else{
//           pageUrl += '?page=1&sort_by=created-ascending';
//           window.location.href = pageUrl;
          
//         }
//      }
// });

jQuery(document).ready(function($){

    var pageUrl = window.location.href;

    // Skip if we are in Shopify theme editor or preview mode
    if (pageUrl.indexOf("preview_theme_id") > -1) return;

    // if (pageUrl.indexOf("collections") > -1) {
    //     if (pageUrl.indexOf("sort_by") === -1) {
    //         pageUrl += (pageUrl.indexOf('?') > -1 ? '&' : '?') + 'page=1&sort_by=created-ascending';
    //         // pageUrl += (pageUrl.indexOf('?') > -1 ? '&' : '?') + 'page=1';
    //         window.location.href = pageUrl;
    //     }
    // }

    // accordion
    $('.accordion-header').on('click', function () {
    const isActive = $(this).hasClass('active');
    $('.accordion-header').removeClass('active');
    $('.accordion-content').slideUp();

    if (!isActive) {
      $(this).addClass('active');
      $(this).next('.accordion-content').slideDown();
    }
  });

  $(".awardPolyphenolsValue").each(function() {
    var str = $(this).html();
    var spaceChar = str.indexOf(" ");
    var reqstr = str.substring(0, spaceChar);
    var result = reqstr + "<small>"+str.substring(spaceChar) + "</small>";
    $(this).html(result);
  });

  $('a.smoothScroll').click(function () {
    $('html, body').animate({
        scrollTop: $( $(this).attr('href') ).offset().top
    }, 500);
    return false;
});


});
